(function () {
  'use strict';

  function setup() {
    document.querySelectorAll('.t4s-facet').forEach(function (facet) {
      var title = facet.querySelector('.t4s-facet-title');
      if (!title || title.getAttribute('data-mc-collapse')) return;
      title.setAttribute('data-mc-collapse', '1');
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-expanded', 'true');

      function toggle() {
        var collapsed = facet.classList.toggle('is--mc-collapsed');
        title.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      }
      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  function boot() {
    setup();
    var container = document.getElementById('t4s-filter-hidden') || document.body;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        setup();
      });
    }).observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
